import { Observable } from 'rxjs';
import { IConfig } from '@vivli/shared/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { AmrTranslationsConstant, DefaultTranslationsConstant } from '@vivli/shared/infrastructure/constants';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { IAnonmyousApi } from '@vivli/core/infrastructure/interface';
import { useRestApi } from '../common';

const getAssignedAppTypeTranslations = (assignedAppType: AssignedAppTypeEnum) => {
    if (assignedAppType === AssignedAppTypeEnum.Amr) {
        return AmrTranslationsConstant;
    }

    return DefaultTranslationsConstant;
};

export const useAnonymousApi = (): IAnonmyousApi => {
    const { handleGet } = useRestApi({ endpoint: '/' });

    const getConfig = (): Observable<IConfig> => {
        return handleGet<IConfig>('/config');
    };

    const getTranslations = (assignedAppType: AssignedAppTypeEnum): Observable<any> => {
        const json = getAssignedAppTypeTranslations(assignedAppType);
        return new Observable((observer) => {
            observer.next(json);
            observer.complete();
        });
    };

    const getStudyMetadata = (searchResultId: string): Observable<IStudy> => {
        return handleGet<IStudy>(`api/studies/${searchResultId}/metadata`);
    };

    return {
        getConfig,
        getTranslations,
        getStudyMetadata
    };
};
